import React from "react"
import "./TMHFooterStyles.css"

function TMHFooter() {
  return (
    <nav className="wrapper-footer">
      <a href="/tmh/#/privacy-policy" target="_blank">
        Privacy policy
      </a>
      <a href="/tmh/#/terms-conditions" target="_blank">
        Terms &#38; conditions
      </a>
      <a href="/tmh/#/about" target="_blank">
        About The Movie House
      </a>
    </nav>
  )
}

export default TMHFooter
